import { Link } from 'react-router-dom';
import { allCourses } from '@/lib/content';

export default function Home() {
  return (
    <>
      <header className="home-header">
        <div className="badge">FIT · BCBA</div>
        <h1>Florida Tech <span>BCBA Quizzes</span></h1>
        <p>Pick a course</p>
      </header>

      {allCourses.length === 0 ? (
        <div className="empty-state">
          <h2>No courses yet</h2>
          <p>Drop a JSON file into <code>src/content/&lt;course&gt;/</code> to get started.</p>
        </div>
      ) : (
        <div className="course-list">
          {allCourses.map((course) => (
            <Link key={course.slug} to={`/c/${course.slug}`} className="course-card">
              <div className="cc-code">{course.code}</div>
              <div className="cc-title">{course.title}</div>
              <div className="cc-meta">
                {course.units.length === 1
                  ? `Unit ${course.units[0].unitNumber}`
                  : `${course.units.length} units`}
              </div>
            </Link>
          ))}
        </div>
      )}
    </>
  );
}
